import { FC } from "react";
import { Button, Modal } from "shared/components";
import { InfoCircle } from "untitledui-js-base";

type Props = {
  opened: boolean;
  onClose: () => void;
  onDelete: () => void;
};

export const DeletePropertyModal: FC<Props> = ({
  opened,
  onClose,
  onDelete
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="max-w-[366px] items-center flex flex-col p-6"
    >
      <div className="mb-4 rounded-full bg-danger-50 p-4">
        <InfoCircle className="stroke-danger-500" size="32" />
      </div>
      <p className="mb-4 text-center text-xl font-bold">
        Are you sure you want to delete this property?
      </p>
      <div className="mb-8 flex items-center justify-center rounded-lg bg-danger-50 p-4">
        <ul className="list-disc pl-4">
          <li className="text-sm font-medium text-danger-600">
            All units in this property will also be deleted
          </li>
        </ul>
      </div>
      <div className="flex w-full gap-2.5">
        <div className="flex-grow">
          <Button className="w-full" onClick={onClose}>
            Cancel
          </Button>
        </div>
        <div className="flex-grow">
          <Button
            className="w-full bg-danger-600 text-content-1000-inverted hover:bg-danger-700"
            onClick={onDelete}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};
